export const TEXT_BUTTON_LINK = 'text-button-link';
export const WEB_LINK = 'web-link';
export const ANCHOR_LINK = 'anchor-link';
export const LINK_PLUGIN_EDIT_BUTTON = 'edit-link-button';
export const LINK_PLUGIN_REMOVE_BUTTON = 'remove-link-button';
export const LINK_PLUGIN_WEB_LINK_BUTTON = 'go-to-link-button';
export const LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON = 'scroll-to-anchor-button';
